import { Box, Grid, IconButton, Stack, Tooltip } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { BinIcon } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { OperationalEquipmentAdd } from './OperationalEquipmentAdd'

interface Props {
  canAddAssignment: boolean
  onAdd: () => void
  onRemove: () => void
}
export const OperationalEquipmentAssignmentActions = observer(
  ({ canAddAssignment, onAdd, onRemove }: Props) => {
    const { t } = useTranslate()

    return (
      <Grid size={2}>
        <Stack flexDirection='row' gap={1} justifyContent='end' marginRight={1}>
          <Tooltip title={t('remove', 'Remove')}>
            <IconButton onClick={onRemove}>
              <BinIcon />
            </IconButton>
          </Tooltip>

          <Box width='2rem'>
            <OperationalEquipmentAdd canAdd={canAddAssignment} onAdd={onAdd} />
          </Box>
        </Stack>
      </Grid>
    )
  },
)
